module.exports = __webpack_public_path__ + "static/default-e7cf9b0599607b8e2edfed1a6a1f0a01.jpg";